const userState = {
    authenticated: false,
    user: {
        language: null,
        fullName: '',
        branch: '',
        role: '',
        products: []
    },
    sidIdentifier: ''
}

export const home = {
    namespaced: true,
    state: userState,
    actions: {
        setUserState ({ commit }, data) {
            commit('setUserState', data)
        },
        setSidIdentifier ({ commit }, sidIdentifier) {
            commit('setSidIdentifier', sidIdentifier)
        }
    },
    mutations: {
        setUserState (state, data) {
            state.authenticated = data.authenticated
            state.user.language = data.language
            state.user.fullName = data.fullName
            state.user.branch = data.branch
            state.user.role = data.role
            state.user.products = data.products
        },
        setSidIdentifier (state, setSidIdentifier) {
            state.sidIdentifier = setSidIdentifier
        }
    },
    getters: {
        sidIdentifier: (state) => {
            return state.sidIdentifier
        },
        userFullname: (state) => {
            return state.user.fullName
        },
        userBranch: (state) => {
            return state.user.branch
        },
        userRole: (state) => {
            return state.user.role
        },
        userIsAuthenticated: (state) => {
            return state.authenticated
        }
    }
}